import VerifyEmailBody from '@/components/verify-email/verify-email-body';
import VerifyEmailFooter from '@/components/verify-email/verify-email-footer';
import VerifyEmailHeader from '@/components/verify-email/verify-email-header';
import { Modal } from '@cmpsr/components';
import { OnDone } from '../../edit-email-address.controller';
import useModalVerifyEmailController from './modal-verify-email.controller';

type ModalVerifyEmailProps = {
  isOpen: boolean;
  onCloseClick: () => void;
  newEmail: string;
  onDone: OnDone<void>;
};

export default function ModalVerifyEmail({ isOpen, onCloseClick, newEmail, onDone }: ModalVerifyEmailProps) {
  const { form, handleResendCode, handleSubmit, countdown, showResend, isSubmitAllowed } =
    useModalVerifyEmailController(newEmail, onDone);

  return (
    <Modal isOpen={isOpen} onClose={onCloseClick} isCentered>
      <Modal.Overlay bg="background-overlay" backdropFilter="auto" />
      <Modal.Content
        bg="background-page"
        borderRadius="radii-2"
        width={{ base: '343px', lg: '408px' }}
        p={{ base: 'spacer-5', lg: 'spacer-10' }}
        gap="spacer-6"
      >
        <Modal.Header bg="background-page" p={0}>
          <VerifyEmailHeader
            variant="text-header-2XL"
            textStyle="text-header-2xl-v"
            color="text-secondary"
            email={newEmail}
          />
        </Modal.Header>
        <form onSubmit={handleSubmit}>
          <Modal.Body bg="background-page" display="flex" flexDirection="column" gap="spacer-6" p={0}>
            <VerifyEmailBody
              size={{
                base: 'm',
                lg: 'l',
              }}
              isFormControlInvalid={!!form.formState.errors.otp?.message}
              pinInputProps={{
                isInvalid: !!form.formState.errors.otp?.message,
                onChange: (val) => {
                  form.clearErrors('otp');
                  form.setValue('otp', val, { shouldValidate: val.length === 6 });
                },
                isDisabled: form.formState.isSubmitting,
              }}
              formErrorMessage={form.formState.errors.otp?.message}
            />
          </Modal.Body>
          <Modal.Footer bg="background-page" flexDirection="column" gap="spacer-6" mt="spacer-6" p={0}>
            <VerifyEmailFooter
              textButton="Verify"
              color="text-secondary"
              onClick={handleResendCode}
              buttonProps={{
                isDisabled: !isSubmitAllowed || !!form.formState.errors.otp,
                isLoading: form.formState.isSubmitting,
              }}
              showResend={showResend}
              countdown={countdown}
            />
          </Modal.Footer>
        </form>
      </Modal.Content>
    </Modal>
  );
}
